import { combineReducers } from 'redux';
import types from './types';

const region = (
  state: string = 'US',
  {
    type,
    payload
  }: {
    type: string;
    payload: string;
  }
) => {
  switch (type) {
    case types.SET_REGION:
      return payload;

    default:
      return state;
  }
};

const language = (
  state: string = 'en-US',
  {
    type,
    payload
  }: {
    type: string;
    payload: string;
  }
) => {
  switch (type) {
    case types.SET_LANGUAGE:
      return payload;

    default:
      return state;
  }
};

const currency = (
  state: string = 'USD',
  {
    type,
    payload
  }: {
    type: string;
    payload: string;
  }
) => {
  switch (type) {
    case types.SET_CURRENCY:
      return payload;

    default:
      return state;
  }
};

export default combineReducers({ region, language, currency });
